import processingView from '../../../../share/components/vue/ProcessingIcon';
import fullModal from "../../../../share/components/vue/FullModal";
import { default as noTextSvgButton } from "../../../../share/components/vue/NoTextSVGButton";
import wrappedTeleport from "../../../../share/components/vue/WrappedTeleport";
import customProgress from "../../../../share/components/vue/CustomProgress";
import dataMonitor from '../../../vue/dataMonitor/DataMonitor';
import DataMonitorPage from "../dataMonitor/DataMonitorPage";
import dmUtil from "../../../pages/dataMonitor/dataMonitorUtil";

export default {
  name: "multipleDataMonitorPage",

  components: {
    processingView,
    dataMonitor,
    fullModal,
    noTextSvgButton,
    wrappedTeleport,
    customProgress
  },

  props: {
    isActiveTest: Boolean,
    isOnlyCsvExport: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  setup(props, ctx) {
    // マルチデータモニタの再生画面を指定
    const dataMonitorFunctionSettings = new dmUtil.DataMonitorFunctionSettings(dmUtil.TYPE_CALLER.MULTI_DM_PLAY); // DM機能の設定インスタンス

    /**
     * 計測画面全体をteleportさせるモーダルダイアログのIDを作成。再生画面でのID被りを避けるため、オーバーライド
     */
    function modalContentId() {
      return `full-modal-content-${dataMonitorFunctionSettings.typeCaller}`;
    }

    /**
     * 計測画面全体をteleportさせるモーダルダイアログのIDを作成。再生画面でのID被りを避けるため、オーバーライド
     * @returns {string} 作成したID
     */
    function graphSettingsDestinationId() {
      return `graph-settings-destination-${dataMonitorFunctionSettings.typeCaller}`;
    }

    return {
      ...DataMonitorPage.setup(props, ctx),
      dataMonitorFunctionSettings,
      modalContentId,
      graphSettingsDestinationId
    };
  }
};
